import React, { useEffect, useState } from "react";
import { Box, Heading, Text } from "@chakra-ui/react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGlobe, faMapLocationDot, faPhone } from "@fortawesome/free-solid-svg-icons";
import { LoadScript, GoogleMap, Marker } from "@react-google-maps/api";
import VaccineInventoryTable from "./VaccineInventoryTable";
import * as IconButton from "../themes/IconButtonSet";

const mapContainerStyle = {
  width: "100%",
  height: "500px",
};

const googleMapsApiKey = "AIzaSyDurY9bFwHW6VvufwuNx2eLC0gDgjGqgCE";

const MapOfficeLocation = () => {
  const [searchParams] = useSearchParams();
  const officeName = searchParams.get("office");
  const { sessionId } = useAuth();
  const navigate = useNavigate();
  const [officesData, setOfficesData] = useState([]);
  const [officeInfo, setOfficeInfo] = useState(null);

  useEffect(() => {
    fetch("/data/offices.json")
      .then((res) => res.json())
      .then((data) => {
        setOfficesData(data);
      });
  }, []);

  useEffect(() => {
    if (officesData.length > 0 && officeName) {
      const office = officesData.find((o) => o.name === officeName);
      if (office) {
        setOfficeInfo({
          id: office.warehouseid, // ถ้ามี ID ก็เพิ่มตรงนี้ภายหลัง
          lat: office.latitude,
          lng: office.longitude,
          address: office.address,
          phone: office.phone,
          website: office.website,
        });
      }
    }
  }, [officesData, officeName]);

  const handleLinkClick = (url) => {
    window.open(url, "_blank");
  };

  return (
    <Box maxW="70%" mx="auto" p={5} bg="white" borderRadius="lg" boxShadow="lg">
      {officeInfo ? (
        <>
          <Box textAlign="right" mt={2}>
            <IconButton.Back onClick={() => navigate(-1)} />
          </Box>
          <Box mb={5}>
            <Heading size="lg" mb={4}>{officeName}</Heading>
            <Text fontSize="lg" mb={2}>
              <FontAwesomeIcon icon={faMapLocationDot} style={{ marginRight: "5px" }} />
              {officeInfo.address}
            </Text>
            <Text fontSize="md" mb={2}>
              <FontAwesomeIcon icon={faPhone} style={{ marginRight: "5px" }} />
              โทร: {officeInfo.phone}
            </Text>
            <Text fontSize="md" mb={2}>
              <FontAwesomeIcon icon={faGlobe} style={{ marginRight: "5px" }} />
              เว็บไซต์:{" "}
              <a
                href={officeInfo.website}
                onClick={() => handleLinkClick(officeInfo.website)}
                target="_blank"
                rel="noopener noreferrer"
              >
                {officeInfo.website}
              </a>
            </Text>
          </Box>
          <VaccineInventoryTable
            warehouseId={officeInfo.id}
            sessionId={sessionId}
          />
          <Box mb={5} height="400px">
            <LoadScript googleMapsApiKey={googleMapsApiKey}>
              <GoogleMap
                mapContainerStyle={mapContainerStyle}
                center={{ lat: officeInfo.lat, lng: officeInfo.lng }}
                zoom={15}
              >
                <Marker
                  key={officeInfo.name}
                  position={{ lat: officeInfo.lat, lng: officeInfo.lng }}
                  title={officeName}
                  onClick={() =>
                    window.open(
                      `https://www.google.com/maps/dir/?api=1&destination=${officeInfo.lat},${officeInfo.lng}&travelmode=driving`,
                      "_blank"
                    )
                  }
                />
              </GoogleMap>
            </LoadScript>
          </Box>
        </>
      ) : (
        <Text textAlign="center" color="red.500" fontSize="xl" p={5}>
          ไม่พบข้อมูลสำนักงาน
        </Text>
      )}
    </Box>
  );
};

export default MapOfficeLocation;
